<template>
    <header id="koreit-header"
        :class="{ active: state.isMenuActive }">
        <h1 v-if="state.isEngMenuOn" id="eng-koreit-logo"><a href="/eng-main.html" title="Go to Main"><span class="text_hidden">Koreit</span></a></h1>
        <h1 v-else id="koreit-logo"><a href="/main.html" title="메인으로 이동"><span class="text_hidden">한국토지신탁</span></a></h1>
        
        <!-- 상단 메뉴 -->
        <nav id="koreit-gnb">
            <MenuNavigation ref="topMenu"
                :menuNavigationType="1"
                :onRootMenuClick="eventHandler.onRootMenuClick"
                :onTwoDepthMenuClick="eventHandler.onTwoDepthMenuClick"
                :onThreeDepthMenuClick="eventHandler.onThreeDepthMenuClick"
                :onRootMenuMouseOver="eventHandler.onRootMenuMouseOver"
                :onRootMenuMouseOut="eventHandler.onRootMenuMouseOut" />
        </nav>

        <!-- 검색, 국문, 영문 버튼 영역 -->
        <div class="h-util">
            <ul class="h-lang">
                <li :class="{ on: state.isKorMenuOn }"><a href="#" @click="eventHandler.onKorButtonClick" title="KOR">KOR</a></li>
                <li :class="{ on: state.isEngMenuOn }"><a href="#" @click="eventHandler.onEngButtonClick" title="ENG">ENG</a></li>
            </ul>
            <button v-if="state.isKorMenuOn" type="button" title="검색" class="h-sch" @click="state.isSearchOn = true">
                <span class="text_hidden">검색</span>
            </button>
        </div>
        <button type="button" id="menuToggle" @click="state.isMenuActive = state.isMenuActive ? false : true"><span></span><span></span><span></span></button>

        <!-- 메뉴 맵 -->
        <div id="all-gnb">
            <MenuNavigation ref="menuMap"
                :menuNavigationType="2"
                :onRootMenuClick="eventHandler.onRootMenuClick"
                :onTwoDepthMenuClick="eventHandler.onTwoDepthMenuClick"
                :onThreeDepthMenuClick="eventHandler.onThreeDepthMenuClick" 
                :onSideButtonClick="eventHandler.onSideButtonClick"/>
        </div>
    </header>

    <!-- 상단 검색 영역 -->
    <div v-if="state.isKorMenuOn" :class="[
        { 'header-sch': true },
        { on: state.isSearchOn }
    ]">
        <div>
            <input type="text" placeholder="검색어를 입력해 주세요" @keyup.enter="eventHandler.onTotalSearchClick" v-model="state.searchKeyword">
            <button type="submit" title="검색" @click="eventHandler.onTotalSearchClick">
                <span class="text_hidden">검색</span>
            </button>
        </div>
        <button type="button" title="검색 닫기" class="sch-close" @click="state.isSearchOn = false">
            <span class="text_hidden">검색 닫기</span>
        </button>
    </div>

    <div id="sub-visual" :class="!!state.selectedRootMenuInfo ? state.selectedRootMenuInfo.backgroundClass : 'sub-visual1'">
        <div class="s-inner">
            <!-- <h2 v-if="state.isEngMenuOn">{{ !!state.selectedRootMenuInfo ? state.selectedRootMenuInfo.title : '' }}</h2> -->
            <h2 v-if="state.isEngMenuOn">{{ !!state.selectedTwoDepthMenuInfo ? state.selectedTwoDepthMenuInfo.title : '' }}</h2>
            <h3 v-else>{{ !!state.selectedTwoDepthMenuInfo ? state.selectedTwoDepthMenuInfo.title : '' }}</h3>
        </div>
    </div>

    <!-- 국문 메뉴 -->
    <div v-if="state.isKorMenuOn" :class="[
        { 'sub-menu-wrap': true },
        { on: state.isThreeDepthMenuOn }, 
    ]">
        <div class="s-inner">
            <div class="tit">
                <h3>{{ !!state.selectedTwoDepthMenuInfo ? state.selectedTwoDepthMenuInfo.title : '' }}</h3>
                <button type="button" title="메뉴 열기" @click="state.isThreeDepthMenuOn = state.isThreeDepthMenuOn ? false : true">
                    <span class="text_hidden">메뉴 열기</span>
                </button>
            </div>
            <ul v-if="state.selectedTwoDepthMenuInfo">
                <li v-for="childMenuInfo in state.selectedTwoDepthMenuInfo.children" v-bind:key="childMenuInfo"
                    :class="{ on: !!state.selectedThreeDepthMenuInfo && childMenuInfo.title === state.selectedThreeDepthMenuInfo.title }">
                    <router-link
                        :to="childMenuInfo.path"
                        :title="childMenuInfo.title"
                        @click="eventHandler.onThreeDepthMenuClick(3, state.selectedRootMenuInfo, state.selectedTwoDepthMenuInfo, childMenuInfo)">{{childMenuInfo.title}}</router-link>
                </li>
            </ul>
        </div>
    </div>

    <!-- 영문메뉴 -->
    <div v-else id="sub-menu-wrap">
        <div class="s-inner">
            <p class="home"><span>Home</span></p>
            <div class="depth1">
                <a href="#" :title="state.selectedRootMenuInfo.title">{{ state.selectedRootMenuInfo.title }}</a>
            </div>
            <div class="depth2">
                <a href="#"
                    :class="{on: state.isTwoDepthMenuOn}"
                    :title="state.selectedTwoDepthMenuInfo.title"
                    @click="state.isTwoDepthMenuOn = !state.isTwoDepthMenuOn">{{ state.selectedTwoDepthMenuInfo.title }}</a>
                <ul v-if="state.selectedRootMenuInfo && state.isEngMenuOn">
                    <li v-for="childMenuInfo in state.selectedRootMenuInfo.children" v-bind:key="childMenuInfo"
                        :class="{ on: !!state.selectedTwoDepthMenuInfo && childMenuInfo.title === state.selectedTwoDepthMenuInfo.title }">
                        <router-link
                            :to="childMenuInfo.path"
                            :title="childMenuInfo.title"
                            @click="eventHandler.onTwoDepthMenuClick($event, 3, state.selectedRootMenuInfo, childMenuInfo)">{{childMenuInfo.title}}</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <!-- 컨텐츠 -->
    <router-view :key="$route.fullPath"
        :onRootMenuClick="eventHandler.onRootMenuClick"
        :onTwoDepthMenuClick="eventHandler.onTwoDepthMenuClick"
        :onThreeDepthMenuClick="eventHandler.onThreeDepthMenuClick" />

    <!-- 푸터 영역 -->
    <Footer :isKorMenuOn="state.isKorMenuOn" :onFooterMenuClick="eventHandler.onFooterMenuClick" />
</template>
<script>
import { onMounted, reactive, ref } from '@vue/runtime-core';
import { menuDataSource } from '@/modules/menu-management.js';
import { useRouter, useRoute } from 'vue-router';
import { menuType } from '@/modules/menu-management.js';
import MenuNavigation from '@/components/MenuNavigation.vue';
import Footer from '@/components/Footer.vue';
import { common } from '@/modules/common.js';
import { useStore } from 'vuex';
export default {
    components: {
        MenuNavigation,
        Footer,
    },
    setup() {

        // 최상단 메뉴 ref
        const topMenu = ref(null);

        // 메뉴맵 ref
        const menuMap = ref(null);

        // 라우터
        const router = useRouter();

        // 라우트
        const route = useRoute();

        // 스토어
        const store = useStore();

        // state (변수)
        const state = reactive({

            // 국문메뉴 on 여부
            isKorMenuOn: true,

            // 영문메뉴 on 여부
            isEngMenuOn: false,

            // 홈 페이지 경로
            homePagePathName: '/home',

            // 현재 페이지 경로
            currentPagePathName: location.pathname,

            // 검색영역 on 여부
            isSearchOn: false,

            // 상단 메뉴영역 active 여부
            isMenuActive: false,

             // 2뎁스 메뉴 on 여부
            isTwoDepthMenuOn: false,

            // 3뎁스 메뉴 on 여부 (모바일 화면일 경우)
            isThreeDepthMenuOn: false,

            // 선택한 최상위 메뉴 정보
            selectedRootMenuInfo: null,

            // 선택한 2뎁스 메뉴 정보
            selectedTwoDepthMenuInfo: null,

            // 선택한 3뎁스 메뉴 정보
            selectedThreeDepthMenuInfo: null,

            // 검색 키워드
            searchKeyword: null,
        });

        // 이벤트 핸들러
        const eventHandler = {

            /**
             * 통합검색 버튼 클릭 이벤트 처리
             */
            onTotalSearchClick: () => {
                
                // 검색영역 닫기
                state.isSearchOn = false;

                // 3뎁스 메뉴 정보 설정 (통합검색)
                state.selectedThreeDepthMenuInfo = menuDataSource.find(data => data.menuId === 'KOR-MENU0101');
                console.log("state.selectedThreeDepthMenuInfo : ", state.selectedThreeDepthMenuInfo)
                // 2뎁스 메뉴 정보 설정
                state.selectedTwoDepthMenuInfo = menuDataSource.find(data => data.menuId === state.selectedThreeDepthMenuInfo.parentMenuId);

                // 최상위 루트 메뉴 정보 설정
                state.selectedRootMenuInfo = menuDataSource.find(data => data.menuId === state.selectedTwoDepthMenuInfo.parentMenuId);

                // 통합검색 화면으로 라우팅
                router.push({
                    path: '/others/total-search',
                    query: { keyword: state.searchKeyword },
                });

                state.searchKeyword = null;
            },

            /**
             * 국문 메뉴 버튼 클릭 이벤트 처리
             */
            onKorButtonClick: (event) => {

                event.preventDefault();

                state.isKorMenuOn = true;
                state.isEngMenuOn = false;

                topMenu.value.setMenuItems(menuType.kor);
                menuMap.value.setMenuItems(menuType.kor);
                
                // 메뉴유형값 설정 (session storage)
                sessionStorage.setItem('menuType', menuType.kor);

                // 메인으로 이동
                router.push({ path: '/' });
            },

            /**
             * 영문 메뉴 버튼 클릭 이벤트
             */
            onEngButtonClick: (event) => {

                event.preventDefault();
                
                state.isKorMenuOn = false;
                state.isEngMenuOn = true;

                topMenu.value.setMenuItems(menuType.eng);
                menuMap.value.setMenuItems(menuType.eng);

                // 메뉴유형값 설정 (session storage)
                sessionStorage.setItem('menuType', menuType.eng);

                // 메인으로 이동
                router.push({ path: '/' });
            },

            /**
             * footer 메뉴 클릭 이벤트 처리 (이메일주소 무단수집거부, 개인정보취급방침, 이용약관, 온라인상담)
             */
            onFooterMenuClick: (event, menuId, NotPolicy = true) => {
                
                // a tag 이벤트 막기
                event.preventDefault();

                // 3뎁스 메뉴 정보 설정 (메뉴ID 기준)
                state.selectedThreeDepthMenuInfo = menuDataSource.find(data => data.menuId === menuId);

                topMenu.value.setMenuItems(state.selectedThreeDepthMenuInfo.menuType);
                menuMap.value.setMenuItems(state.selectedThreeDepthMenuInfo.menuType);

                // 2뎁스 메뉴 정보 설정
                state.selectedTwoDepthMenuInfo = menuDataSource.find(data => data.menuId === state.selectedThreeDepthMenuInfo.parentMenuId);

                // 최상위 루트 메뉴 정보 설정
                state.selectedRootMenuInfo = menuDataSource.find(data => data.menuId === state.selectedTwoDepthMenuInfo.parentMenuId);

                if (NotPolicy) {
                    
                    // 화면 이동
                    router.push({ path: state.selectedThreeDepthMenuInfo.path }).then(() => {

                        // 최상단으로 스크롤 이동
                        window.scrollTo({ top: 0, behavior: "smooth" });
                    });
                } else {
                    const isSameRoute = route.path === '/company/service-center/pri';
                    const isSameHash = route.hash === '#privacy-policy';
                    if (isSameRoute && isSameHash) {
                        window.scrollTo({
                            top: document.getElementById('privacy-policy').getBoundingClientRect().top + window.scrollY,
                            left: 0,
                            behavior: 'smooth'
                        });
                    } else {
                        router.push({ path: state.selectedThreeDepthMenuInfo.path, hash: '#privacy-policy' })
                    }
                }
                
            },

            /**
             * 최상위 메뉴 클릭 이벤트 처리
             * @param {any} event
             * @param {Number} menuNavigationType : 메뉴 네비게이션 유형 (1: 상단 메뉴영역, 2: 메뉴맵, 3: 사이트맵 페이지 내 메뉴 맵)
             * @param {Object} menuInfo : 메뉴 정보
             */
            onRootMenuClick: (event, menuNavigationType, menuInfo) => {
                
                // a tag 이벤트 막기
                event.preventDefault();
                event.target.parentNode.classList.toggle('on');
            },

            /**
             * 2뎁스 메뉴 클릭 이벤트 처리
             * @param {any} event
             * @param {Number} menuNavigationType : 메뉴 네비게이션 유형 (1: 상단 메뉴영역, 2: 메뉴맵, 3: 사이트맵 페이지 내 메뉴 맵)
             * @param {Object} rootMenuInfo : 최상위 메뉴 정보
             * @param {Object} menuInfo : 메뉴 정보
             */
            onTwoDepthMenuClick: (event, menuNavigationType, rootMenuInfo = null, menuInfo = null) => {

                if (state.isEngMenuOn) {

                    // 2뎁스 메뉴 비활성화
                    state.isTwoDepthMenuOn = false;

                    // 메뉴정보 설정
                    state.selectedRootMenuInfo = rootMenuInfo;
                    state.selectedTwoDepthMenuInfo = menuInfo;

                    document.getElementById("koreit-header").classList.remove('on');
                    state.isMenuActive = false;

                    // 최상단으로 스크롤 이동
                    window.scrollTo({ top: 0, behavior: "smooth" });

                    const twoDepthMenuElements = [...document.querySelectorAll(".depth2 > ul > li")];

                    // 대상메뉴 밑줄 표시 (나머지는 제거)
                    twoDepthMenuElements.forEach(element => {

                        if (element.querySelector("a").text === menuInfo.title) element.classList.add("active");
                        else element.classList.remove("active");
                    });
                }
                else {

                    // 메뉴 네비게이션 유형이 상단 메뉴영역일 시
                    if (menuNavigationType === 1) {

                        // 현재 메뉴 toggle on 여부
                        const isOn = event.target.parentNode.classList.value.includes("on");

                        // 3뎁스 메뉴 element 목록
                        const threeDepthMenuAreaElements = event.target.parentNode.parentNode.parentNode.parentNode.querySelectorAll('.depth3');
                        
                        // 이전 메뉴영역 닫기
                        threeDepthMenuAreaElements.forEach(element => element.classList.remove('on'));

                        // 현재 메뉴영역 toggle on (on 상태면 off)
                        if (rootMenuInfo && menuInfo) event.target.parentNode.classList.toggle('on');
                        else isOn ? event.target.parentNode.classList.toggle('off') : event.target.parentNode.classList.toggle('on');
                    }
                    else {
                        //event.target.parentNode.classList.toggle('on');
                        
                        // 메뉴정보 설정
                        state.selectedRootMenuInfo = rootMenuInfo;
                        state.selectedTwoDepthMenuInfo = menuInfo;
                        const representativeMenu = menuInfo.children.find(child => child.isRepresentativeMenu);
                        state.selectedThreeDepthMenuInfo = representativeMenu;

                        document.getElementById("koreit-header").classList.remove('on');
                        state.isMenuActive = false;

                        //2depth 메뉴 element 목록
                        //const twoDepthMenuElements = [...document.querySelectorAll(".depth3")];
                        const twoDepthMenuElements = event.target.parentNode.parentNode.parentNode.parentNode.parentNode.querySelectorAll('.depth2')

                        //대상메뉴 확장 (나머지는 제거)
                        twoDepthMenuElements.forEach(element => {

                            if (element.querySelector("a").text === rootMenuInfo.title) element.classList.add('on');
                            else element.classList.remove('on');
                        });

                        // 3뎁스 메뉴 element 목록
                        const threeDepthMenuAreaElements = event.target.parentNode.parentNode.parentNode.parentNode.querySelectorAll('.depth3');
                        
                        // 이전 메뉴영역 닫기
                        threeDepthMenuAreaElements.forEach(element => element.classList.remove('on'));
                    }

                    if (!!menuInfo) {

                        if(event.target.parentNode.classList[1] == 'on'){

                            // 2뎁스 메뉴 클릭 시 3뎁스 대표메뉴로 이동
                            const representativeMenu = menuInfo.children.find(child => child.isRepresentativeMenu);
                            representativeMenu && eventHandler.onThreeDepthMenuClick(menuNavigationType, rootMenuInfo, menuInfo, representativeMenu);
                        }
                        
                    }
                }
            },

            /**
             * 3뎁스 메뉴 클릭 이벤트 처리
             * @param {Number} menuNavigationType : 메뉴 네비게이션 유형 (1: 상단 메뉴영역, 2: 메뉴맵, 3: 사이트맵 페이지 내 메뉴 맵)
             * @param {Object} rootMenuInfo : 최상위 메뉴 정보
             * @param {Object} twoMenuInfo : 2뎁스 메뉴 정보
             * @param {Object} threeMenuInfo : 3뎁스 메뉴 정보
             */
            onThreeDepthMenuClick: (menuNavigationType, rootMenuInfo, twoMenuInfo, threeMenuInfo) => {
                
                // 메뉴정보 설정
                state.selectedRootMenuInfo = rootMenuInfo;
                state.selectedTwoDepthMenuInfo = twoMenuInfo;
                state.selectedThreeDepthMenuInfo = threeMenuInfo;

                document.getElementById("koreit-header").classList.remove('on');
                state.isMenuActive = false;

                // 3depth 메뉴 element 목록
                const threeDepthMenuElements = [...document.querySelectorAll(".depth3 > ul > li")];

                // 대상메뉴 밑줄 표시 (나머지는 제거)
                threeDepthMenuElements.forEach(element => {

                    if (element.querySelector("a").text === threeMenuInfo.title) element.classList.add("active");
                    else element.classList.remove("active");
                });

                // 
                if (menuNavigationType !== 1) {
                    
                    if(menuNavigationType == 3){

                        state.isThreeDepthMenuOn = false;

                    }else{
                        // 2depth 메뉴 element 목록
                        const twoDepthMenuElements = [...document.querySelectorAll(".depth3")];
                        const rootMenuElements = event.target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.querySelectorAll('.depth2');
                        
                        // 대상메뉴 확장 (나머지는 제거)
                        twoDepthMenuElements.forEach(element => {

                            if (element.querySelector("a").text === twoMenuInfo.title) element.classList.add('on');
                            else element.classList.remove('on');
                        });
                        // 대상메뉴 확장 (나머지는 제거)
                        rootMenuElements.forEach(element => {

                            if (element.querySelector("a").text === rootMenuInfo.title) element.classList.add('on');
                            else element.classList.remove('on');
                        });
                    }
                }
                
                // 최상단으로 스크롤 이동
                window.scrollTo({ top: 0, behavior: "smooth" });
            },

            /**
             * 모바일버전 2뎁스 메뉴 화살표 클릭 이벤트 처리
             * @param {any} event
             */
             onSideButtonClick: (event) => {
                
                event.target.parentNode.parentNode.classList.toggle('on');
            },

            /**
             * 최상위 메뉴 마우스 오버 이벤트 처리
             */
            onRootMenuMouseOver: () => {

                document.getElementById("koreit-header").classList.add('on');
            },

            /**
             * 최상위 메뉴 마우스 아웃 이벤트 처리
             */
            onRootMenuMouseOut: () => {

                document.getElementById("koreit-header").classList.remove('on');
            },
        }

        // 메소드
        const methods = {

            /**
             * 초기작업
             * @param {*} currentMenuInfo : 현재 메뉴 정보
             */
            initialize: (currentMenuInfo) => {

                // 메뉴유형에 따라 메뉴 설정
                switch (sessionStorage.getItem('menuType')) {

                    // 국문
                    case menuType.kor: {

                        // 국문 타이트 설정
                        document.getElementsByTagName('title')[0].text = '한국토지신탁';

                        // 영문 css 적용을 위한 클래스 삭제
                        document.getElementById('wrap').classList.remove('eng');

                        // 국문 css 적용을 위한 클래스 추가
                        document.getElementById('wrap').classList.add('kor');

                        state.isKorMenuOn = true;
                        state.isEngMenuOn = false;
                        topMenu.value.setMenuItems(menuType.kor);
                        menuMap.value.setMenuItems(menuType.kor);

                        // 3뎁스 메뉴 정보 설정
                        state.selectedThreeDepthMenuInfo = currentMenuInfo;

                        // 2뎁스 메뉴 정보 설정
                        state.selectedTwoDepthMenuInfo = menuDataSource.find(data => data.menuId === state.selectedThreeDepthMenuInfo.parentMenuId);

                        // 최상위 루트 메뉴 정보 설정
                        state.selectedRootMenuInfo = menuDataSource.find(data => data.menuId === state.selectedTwoDepthMenuInfo.parentMenuId);

                        if(state.selectedTwoDepthMenuInfo.title == '통합검색'){ //통합검색일 경우에는 초기설정 멈춤
                            break;
                        }
                        // 현재 2depth 메뉴 element
                        const twoDepthMenuElement = [...document.querySelectorAll(".depth3")].find(element => element.querySelector("a").text === state.selectedTwoDepthMenuInfo.title);

                        if(twoDepthMenuElement != undefined){
                            // 현재 3depth 메뉴 element
                            const threeMenuElement = [...twoDepthMenuElement.querySelector("ul").querySelectorAll("li")].find(element => element.querySelector("a").text === currentMenuInfo.title);

                            // 현재 메뉴 여부 반환 boolen
                            const isExistCurrentMenuElement = [...twoDepthMenuElement.querySelector("ul").querySelectorAll("li")].some(element => element.querySelector("a").text === currentMenuInfo.title);

                            // 2depth 메뉴 확장 및 메뉴 및줄 설정
                            if (isExistCurrentMenuElement) {

                                twoDepthMenuElement.classList.toggle("on");
                                threeMenuElement.classList.add("active");
                            }
                        }
                        
                        break;
                    }
                    // 영문
                    case menuType.eng: {

                        // 영문타이트 설정
                        document.getElementsByTagName('title')[0].text = 'Koreit';

                        // 국문 css 적용을 위한 클래스 삭제
                        document.getElementById('wrap').classList.remove('kor');

                        // 영문 css 적용을 위한 클래스 추가
                        document.getElementById('wrap').classList.add('eng');

                        state.isKorMenuOn = false;
                        state.isEngMenuOn = true;
                        topMenu.value.setMenuItems(menuType.eng);
                        menuMap.value.setMenuItems(menuType.eng);

                        // 2뎁스 메뉴 정보 설정 (라우터 경로 기준)
                        state.selectedTwoDepthMenuInfo = menuDataSource.find(data => {

                            return data.path === route.path || (data.detailPath && data.detailPath.includes(route.fullPath.split('?')[0]));
                        });

                        // 최상위 루트 메뉴 정보 설정
                        state.selectedRootMenuInfo = menuDataSource.find(data => data.menuId === state.selectedTwoDepthMenuInfo.parentMenuId);
                        
                        // 영문 메뉴 엘리먼트 객체 그려질 시간 설정
                        setTimeout(() => {
                            
                            // 영문 메뉴 li태크 배열 설정
                            const twoDepthMenuElements = [...document.querySelectorAll(".depth2 > ul > li")];

                            // 대상메뉴 밑줄 표시 (나머지는 제거)
                            twoDepthMenuElements.forEach(element => {

                                if (element.querySelector("a").text === state.selectedTwoDepthMenuInfo.title) element.classList.add("active");
                                else element.classList.remove("active");
                            });
                        }, 100)

                        break;
                    }
                }

                // 스크롤 이벤트 설정
                document.addEventListener('scroll', () => {

                    const koreitHeaderElement = document.getElementById("koreit-header");

                    if (document.documentElement.scrollTop > 0) {

                        if (!koreitHeaderElement.classList.contains('scroll-on')) {

                            koreitHeaderElement.classList.add('scroll-on');
                        }
                    }
                    else koreitHeaderElement.classList.remove('scroll-on');
                });
            },
        }

        onMounted(async () => {

            // 화면설정이 완료될때 까지 화면 숨김
            document.getElementById("wrap").style.display = 'none';

            // client ip store에 설정
            // store.commit("setClientIp", await common.getClientIp());

            // 현재 메뉴 정보 (라우터 경로 기준)
            const currentMenuInfo = menuDataSource.find(data => {

                return data.path === route.path || (data.detailPath && data.detailPath.includes(route.fullPath.split('?')[0]));
            });

            // 현재 메뉴의 유형으로 설정 (session storage)
            sessionStorage.setItem('menuType', currentMenuInfo.menuType);

            methods.initialize(currentMenuInfo);

            // 화면설정이 완료되면 화면 숨김 해제
            document.getElementById("wrap").style.display = 'block';
        });
    
        return {
            state,
            router,
            store,
            eventHandler,
            methods,
            topMenu,
            menuMap,
        }
    },
}
</script>
<style>

    @media screen and (max-width:1024px){
        html, body {overflow-y:auto}
    }

    #all-gnb > ul > li > ul > li > ul > li > router-link {
        display: block;
        width: 100%;
        font-size: 0.875em;
        color: #666;
        padding: 4px 0 4px 13px;
        position: relative;
    }

    #all-gnb > ul > li > ul > li > ul > li > router-link:before {
        content: '-';
        font-weight: 600;
        position: absolute;
        left: 0;
        top: 4px;
    }
</style>